import React, { useEffect } from 'react';
import { Button, Drawer, Form, Input, InputNumber, Select, Space } from 'antd';
import { CanvassQuoteRecord } from '../../../types/Canvass';

/** Records what one supplier said about one item. */
const QuoteDrawer = ({
  open,
  supplier,
  item,
  quote,
  onClose,
  onSave,
}: {
  open: boolean;
  supplier: string;
  item: string;
  quote?: CanvassQuoteRecord;
  onClose: () => void;
  onSave: (v: {
    available?: boolean | null;
    quotedPrice?: number;
    leadTimeDays?: number;
    remarks?: string;
  }) => void;
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue({
      available: quote?.available ?? undefined,
      quotedPrice: quote?.quotedPrice,
      leadTimeDays: quote?.leadTimeDays,
      remarks: quote?.remarks,
    });
  }, [open, quote]);

  return (
    <Drawer
      title={supplier}
      open={open}
      onClose={onClose}
      width={380}
      footer={
        <Space>
          <Button onClick={onClose}>Cancel</Button>
          <Button type={'primary'} onClick={() => form.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      <p className={'mb-3 text-gray-500'}>{item}</p>
      <Form
        form={form}
        layout={'vertical'}
        onFinish={(v) => onSave({ ...v, available: v.available ?? null })}
      >
        <Form.Item
          name={'available'}
          label={'Carries this item?'}
          extra={'Leave blank until they have answered'}
        >
          <Select
            allowClear
            options={[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]}
          />
        </Form.Item>
        <Form.Item name={'quotedPrice'} label={'Quoted Price'}>
          <InputNumber className={'w-full'} min={0} />
        </Form.Item>
        <Form.Item name={'leadTimeDays'} label={'Lead Time (days)'}>
          <InputNumber className={'w-full'} min={0} />
        </Form.Item>
        <Form.Item name={'remarks'} label={'Remarks'}>
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default QuoteDrawer;
